<mat-card class="transparent-card">
    <mat-card-header>
        <mat-card-title>Badge Registry</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-form-field>
            <mat-label>Search</mat-label>
            <input matInput (keyup)="searchBadge($event)">
          </mat-form-field>
        <table mat-table class="transparent-table" [dataSource]="badgeSource" matSort >
            <ng-container matColumnDef="uid">
                <th mat-header-cell *matHeaderCellDef>UID</th>
                <td mat-cell *matCellDef="let badge">
                    {{ badge.uid }}
                </td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let badge">
                    <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                        <mat-label>Badge Type</mat-label>
                        <mat-select [value]="badge.type" (selectionChange)="changeType(badge.uid,  $event.value)">
                            <mat-option value="AAA">AAA</mat-option>
                            <mat-option value="RGA Crew">RGA Crew</mat-option>
                            <mat-option value="RGA Crew - No Food">RGA Crew - No Food</mat-option>
                            <mat-option value="Visitor">Visitor</mat-option>
                            <mat-option value="Security">Security</mat-option>
                            <mat-option value="Creator">Creator</mat-option>
                            <mat-option value="Pro Player 2026">Pro Player 2026</mat-option>
                            <mat-option value="Team Guest 2026">Team Guest 2026</mat-option>                            
                            <mat-option value="Pro Player 2025">Pro Player 2025</mat-option>
                            <mat-option value="Team Guest 2025">Team Guest 2025</mat-option>
                            <mat-option value="Executive Lounge">Executive Lounge</mat-option>
                            <mat-option value="Press">Press</mat-option>
                            <mat-option value="Food Voucher">Food Voucher</mat-option>
                            <mat-option value="default">Unknown</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </ng-container>
            <ng-container matColumnDef="number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Number</th>
                <td mat-cell *matCellDef="let badge">
                <mat-form-field>
                    <input matInput type="number" [value]="badge.number" (keyup.enter)="changeNumber(badge.uid, $event)" (blur)="changeNumber(badge.uid, $event)">
                </mat-form-field>
                </td>
            </ng-container>
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Timestamp</th>
                <td mat-cell *matCellDef="let badge">
                    {{ badge.date | date:'dd.MM.yyyy - HH:mm:ss' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let badge">
                    <mat-icon (click)="removeBadge(badge.uid)">delete</mat-icon>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator class="transparent-paginator" [pageSizeOptions]="[25, 50, 100, 200, 500]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
</mat-card>